import { ArrowUpRight } from "lucide-react";

const SOCIALS = [
  { name: "Spotify", url: "https://open.spotify.com/artist/68Fh9paFtenNWVDTuugOH3" },
  { name: "Audiomack", url: "https://audiomack.com/mr-zeeee" },
  { name: "Apple Music", url: "https://music.apple.com/za/artist/mr-zee/1854755781" },
  { name: "Instagram", url: "https://www.instagram.com/mrzee_ota/" },
];

export default function Footer({ content }) {
  const socials = content?.platform_links
    ? [...content.platform_links, { name: "Instagram", url: "https://www.instagram.com/mrzee_ota/" }]
    : SOCIALS;

  return (
    <footer className="relative z-10 bg-[#0c0c0f] border-t border-zinc-900 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="font-anton text-5xl sm:text-6xl uppercase text-white leading-none">Zee Nation</div>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-zinc-600">
              Real stories · Unfiltered sound
            </p>
          </div>
          <div className="flex flex-wrap gap-5">
            {socials.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wider text-zinc-400 hover:text-rose-500 transition-colors"
                data-testid={`footer-${s.name.toLowerCase().replace(/\s/g, "-")}`}
              >
                {s.name} <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            ))}
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-zinc-900 font-mono text-[11px] uppercase tracking-wider text-zinc-600">
          © {new Date().getFullYear()} Mr Zee. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
